export enum EfdbName {
  eeio = 'eeio',
  ghg_global = 'ghg_global'
}
